import { SyncServiceProvider } from "~/environment/shared-worker/SyncService";

export function observeSyncProgress() {
  return SyncServiceProvider.syncProgress$;
}
